import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {registerUiKitI18n} from '@vedmarket/ui-kit';
import partnersRu from '../pages/partners/main/locales/ru';

const partnersEn = Object.fromEntries(Object.keys(partnersRu).map(key => [key, key]));

i18n
    .use(initReactI18next)
    .init({
        lng: 'ru',
        fallbackLng: 'ru',
        resources: {
            ru: {partners: partnersRu},
            en: {partners: partnersEn},
        },
        interpolation: {
            escapeValue: false,
        },
    });

registerUiKitI18n(i18n);

export default i18n;
